import moment from "moment";

export default {
  name: "Additional Recruitment Requirements for Professional Occupations",
  pageAlert: {
    widget: "pageAlert",
    alerts: [
      {
        title: "Information Required",
        description:
          "Please specify the applicant's Occupation Type in Field H.b within the Preliminary Section of this application",
        type: "info",
        isVisible: {
          when: "occupationType",
          is: "untouched",
          operator: "untouched",
        },
      },
      {
        title: "Section Complete",
        description:
          "Because you indicated that this application is NOT for a professional occupation, this section is not necessary.",
        type: "success",
        isVisible: {
          when: "occupationType",
          is: ["college_university_teacher", "non_professional"],
          operator: "||",
        },
      },
      {
        title: "Section Complete",
        description: `Because you indicated that this application is for a professional athlete, this section is not necessary.`,
        type: "success",
        isVisible: {
          when: "occupationType",
          is: ["professional_athlete"],
          operator: "compareMultiFieldValuesAND_ORInArray",
        },
      },
    ],
  },

  pageInfo: {
    isVisible: {
      when: "occupationType",
      is: ["professional_occupation"],
      operator: "||",
    },
    text: `<b><u>Note:</u></b> If the job for which certification is sought is in a professional occupation, the employer
     must select three additional recruitment steps from the alternatives listed in 20 CFR 656.17(e)(1)(ii)(A)-(J).  Only one of the additional 
     steps may consist solely of activity that took place within 30 days of the filing of the application.  None of the steps may have taken place 
      more than 180 days prior to filing the application, in accordance with 20 CFR 656.17(e)(1)(ii).`,
    coloring: "grey",
  },
  sections: [
    {
      isVisible: {
        when: "occupationType",
        is: ["professional_occupation"],
        operator: "||",
      },
      sectionInfo: {
        text: "<u><b>Important:</b></u> A minimum of three (3) recruitment events listed below must be completed",
        coloring: "grey",
      },
      fields: [
        {
          machine_name: "hDGroup",
          widget: "text",
          hidden: true,
          code: "H.d",
          disabled: true,
          disableWhenField: [
            {
              when: "occupationType",
              is: "professional_athlete",
            },
            {
              when: "occupationType",
              is: "college_university_teacher",
            },
            {
              when: "occupationType",
              is: "non_professional",
            },
          ],
          validate: [
            {
              subsetOfSetRequired: "hDGroup",
              message: "Please complete at least three.",
              needsFieldValues: true,
              extraData: {
                numRequired: 3,
                fieldArray: [
                  "jobFairIncluded",
                  "employerWebsiteIncluded",
                  "jobSearchWebsiteIncluded",
                  "onCampusRecruitingIncluded",
                  "tradeProfessionalIncluded",
                  "privateEmploymentIncluded",
                  "employeeReferralIncluded",
                  "campusPlacementIncluded",
                  "localEthnicNewspaperIncluded",
                  "radioTvAdIncluded",
                ],
              },
            },
          ],
        },
        {
          widget: "generic_table",
          minWidth: "800px",
          headers: [
            { label: "Recruitment Event" },
            { label: "From" },
            { label: "To" },
          ],
          rows: [
            [
              {
                widget: "checkbox",
                machine_name: "jobFairIncluded",
                choice: "Job fair §",
                choiceLabelHidden: true,
                reviewHidden: true,
              },
              {
                widget: "label",
                label: "Job fair §",
              },
              {
                widget: "date",
                machine_name: "jobFairFrom",
                // hideIcons: true,
                noFixedWidth: true,
                code: "H.d.1a",
                label: "1.a",
                tooltip:
                  "Enter the start date for the job fair recruitment MM/DD/YYYY format.",
                disabled: true,
                maxDate: "jobFairTo",
                disableWhenField: {
                  when: "jobFairIncluded",
                  is: 0,
                },
                cellWarning: {
                  text: "The recruitment steps must be conducted at least 30 days, but no more than 180 days, before filing the application.",
                  isVisible: {
                    when: (formApi) => {
                      const value = formApi.getState().values.jobFairFrom;
                      const errors = formApi.getState().errors.jobFairFrom;
                      const included =
                        formApi.getState().values.jobFairIncluded;
                      if (!!included && !!value && !errors) {
                        const today = moment();
                        const dateToCheck = moment(value);
                        const diff = Math.round(
                          today.diff(dateToCheck, "days", true)
                        );
                        return diff > 180 || diff < 30;
                      }
                      return false;
                    },
                    is: "jobFairFromCheck",
                    operator: "customValidation",
                  },
                },
                validate: [
                  {
                    isRequired: "jobFairIncluded",
                    message: "This field is required",
                    needsFieldValues: true,
                    extraData: {
                      valueOf: 1,
                    },
                  },
                  {
                    dateStartEnd: "jobFairTo",
                    message: "From Date must occur before To Date.",
                    needsFieldValues: true,
                    extraData: {
                      type: "start",
                      validateWhen: {
                        field: "jobFairIncluded",
                        is: 1,
                      },
                    },
                  },
                ],
              },
              {
                widget: "date",
                machine_name: "jobFairTo",
                label: "1.b",
                code: "H.d.1b",
                disabled: true,
                // hideIcons: true,
                noFixedWidth: true,
                minDate: "jobFairFrom",
                tooltip:
                  "Enter the end date for the job fair recruitment in MM/DD/YYYY format.",
                disableWhenField: {
                  when: "jobFairIncluded",
                  is: 0,
                },
                cellWarning: {
                  text: "The recruitment steps must be conducted at least 30 days, but no more than 180 days, before filing the application.",
                  isVisible: {
                    when: (formApi) => {
                      const value = formApi.getState().values.jobFairTo;
                      const errors = formApi.getState().errors.jobFairTo;
                      const included =
                        formApi.getState().values.jobFairIncluded;
                      if (!!included && !!value && !errors) {
                        const today = moment();
                        const dateToCheck = moment(value);
                        const diff = Math.round(
                          today.diff(dateToCheck, "days", true)
                        );
                        return diff > 180 || diff < 30;
                      }
                      return false;
                    },
                    is: "jobFairToCheck",
                    operator: "customValidation",
                  },
                },
                validate: [
                  {
                    isRequired: "jobFairIncluded",
                    message: "This field is required",
                    needsFieldValues: true,
                    extraData: {
                      valueOf: 1,
                    },
                  },
                  {
                    dateStartEnd: "jobFairFrom",
                    message: "End Date must occur after Begin Date.",
                    needsFieldValues: true,
                    extraData: {
                      type: "end",
                      validateWhen: {
                        field: "jobFairIncluded",
                        is: 1,
                      },
                    },
                  },
                ],
              },
            ],
            [
              {
                widget: "checkbox",
                machine_name: "employerWebsiteIncluded",
                choice: "Employer website §",
                choiceLabelHidden: true,
                reviewHidden: true,
              },
              {
                widget: "label",
                label: "Employer website §",
              },
              {
                widget: "date",
                machine_name: "employerWebsiteFrom",
                label: "2.a",
                code: "H.d.2a",
                maxDate: "employerWebsiteTo",
                disabled: true,
                // hideIcons: true,
                noFixedWidth: true,
                tooltip:
                  "Enter the start date for the employer website recruitment in MM/DD/YYYY format.",
                disableWhenField: {
                  when: "employerWebsiteIncluded",
                  is: 0,
                },
                cellWarning: {
                  text: "The recruitment steps must be conducted at least 30 days, but no more than 180 days, before filing the application.",
                  isVisible: {
                    when: (formApi) => {
                      const value =
                        formApi.getState().values.employerWebsiteFrom;
                      const errors =
                        formApi.getState().errors.employerWebsiteFrom;
                      const included =
                        formApi.getState().values.employerWebsiteIncluded;
                      if (!!included && !!value && !errors) {
                        const today = moment();
                        const dateToCheck = moment(value);
                        const diff = Math.round(
                          today.diff(dateToCheck, "days", true)
                        );
                        return diff > 180 || diff < 30;
                      }
                      return false;
                    },
                    is: "employerWebsiteFromCheck",
                    operator: "customValidation",
                  },
                },
                validate: [
                  {
                    isRequired: "employerWebsiteIncluded",
                    message: "This field is required",
                    needsFieldValues: true,
                    extraData: {
                      valueOf: 1,
                    },
                  },
                  {
                    dateStartEnd: "employerWebsiteTo",
                    message: "From Date must occur before To Date.",
                    needsFieldValues: true,
                    extraData: {
                      type: "start",
                      validateWhen: {
                        field: "employerWebsiteIncluded",
                        is: 1,
                      },
                    },
                  },
                ],
              },
              {
                widget: "date",
                machine_name: "employerWebsiteTo",
                label: "2.b",
                code: "H.d.2b",
                disabled: true,
                // hideIcons: true,
                noFixedWidth: true,
                tooltip:
                  "Enter the end date for the employer website recruitment in MM/DD/YYYY format.",
                minDate: "employerWebsiteFrom",
                disableWhenField: {
                  when: "employerWebsiteIncluded",
                  is: 0,
                },
                cellWarning: {
                  text: "The recruitment steps must be conducted at least 30 days, but no more than 180 days, before filing the application.",
                  isVisible: {
                    when: (formApi) => {
                      const value = formApi.getState().values.employerWebsiteTo;
                      const errors =
                        formApi.getState().errors.employerWebsiteTo;
                      const included =
                        formApi.getState().values.employerWebsiteIncluded;
                      if (!!included && !!value && !errors) {
                        const today = moment();
                        const dateToCheck = moment(value);
                        const diff = Math.round(
                          today.diff(dateToCheck, "days", true)
                        );
                        return diff > 180 || diff < 30;
                      }
                      return false;
                    },
                    is: "employerWebsiteToCheck",
                    operator: "customValidation",
                  },
                },
                validate: [
                  {
                    isRequired: "employerWebsiteIncluded",
                    message: "This field is required",
                    needsFieldValues: true,
                    extraData: {
                      valueOf: 1,
                    },
                  },
                  {
                    dateStartEnd: "employerWebsiteFrom",
                    message: "End Date must occur after Begin Date.",
                    needsFieldValues: true,
                    extraData: {
                      type: "end",
                      validateWhen: {
                        field: "employerWebsiteIncluded",
                        is: 1,
                      },
                    },
                  },
                ],
              },
            ],
            [
              {
                widget: "checkbox",
                machine_name: "jobSearchWebsiteIncluded",
                choice: "Job search website §",
                choiceLabelHidden: true,
                reviewHidden: true,
              },
              {
                widget: "label",
                label: "Job search website §",
              },
              {
                widget: "date",
                machine_name: "jobSearchWebsiteFrom",
                label: "3.a",
                code: "H.d.3a",
                disabled: true,
                // hideIcons: true,
                noFixedWidth: true,
                tooltip:
                  "Enter the start date for the job search website recruitment in MM/DD/YYYY format.",
                maxDate: "jobSearchWebsiteTo",
                disableWhenField: {
                  when: "jobSearchWebsiteIncluded",
                  is: 0,
                },
                cellWarning: {
                  text: "The recruitment steps must be conducted at least 30 days, but no more than 180 days, before filing the application.",
                  isVisible: {
                    when: (formApi) => {
                      const value =
                        formApi.getState().values.jobSearchWebsiteFrom;
                      const errors =
                        formApi.getState().errors.jobSearchWebsiteFrom;
                      const included =
                        formApi.getState().values.jobSearchWebsiteIncluded;
                      if (!!included && !!value && !errors) {
                        const today = moment();
                        const dateToCheck = moment(value);
                        const diff = Math.round(
                          today.diff(dateToCheck, "days", true)
                        );
                        return diff > 180 || diff < 30;
                      }
                      return false;
                    },
                    is: "jobSearchWebsiteFromCheck",
                    operator: "customValidation",
                  },
                },
                validate: [
                  {
                    isRequired: "jobSearchWebsiteIncluded",
                    message: "This field is required",
                    needsFieldValues: true,
                    extraData: {
                      valueOf: 1,
                    },
                  },
                  {
                    dateStartEnd: "jobSearchWebsiteTo",
                    message: "From Date must occur before To Date.",
                    needsFieldValues: true,
                    extraData: {
                      type: "start",
                      validateWhen: {
                        field: "jobSearchWebsiteIncluded",
                        is: 1,
                      },
                    },
                  },
                ],
              },
              {
                widget: "date",
                machine_name: "jobSearchWebsiteTo",
                label: "3.b",
                code: "H.d.3b",
                disabled: true,
                // hideIcons: true,
                noFixedWidth: true,
                tooltip:
                  "Enter the end date for the job search website recruitment in MM/DD/YYYY format.",
                minDate: "jobSearchWebsiteFrom",
                disableWhenField: {
                  when: "jobSearchWebsiteIncluded",
                  is: 0,
                },
                cellWarning: {
                  text: "The recruitment steps must be conducted at least 30 days, but no more than 180 days, before filing the application.",
                  isVisible: {
                    when: (formApi) => {
                      const value =
                        formApi.getState().values.jobSearchWebsiteTo;
                      const errors =
                        formApi.getState().errors.jobSearchWebsiteTo;
                      const included =
                        formApi.getState().values.jobSearchWebsiteIncluded;
                      if (!!included && !!value && !errors) {
                        const today = moment();
                        const dateToCheck = moment(value);
                        const diff = Math.round(
                          today.diff(dateToCheck, "days", true)
                        );
                        return diff > 180 || diff < 30;
                      }
                      return false;
                    },
                    is: "jobSearchWebsiteToCheck",
                    operator: "customValidation",
                  },
                },
                validate: [
                  {
                    isRequired: "jobSearchWebsiteIncluded",
                    message: "This field is required",
                    needsFieldValues: true,
                    extraData: {
                      valueOf: 1,
                    },
                  },
                  {
                    dateStartEnd: "jobSearchWebsiteFrom",
                    message: "End Date must occur after Begin Date.",
                    needsFieldValues: true,
                    extraData: {
                      type: "end",
                      validateWhen: {
                        field: "jobSearchWebsiteIncluded",
                        is: 1,
                      },
                    },
                  },
                ],
              },
            ],
            [
              {
                widget: "checkbox",
                machine_name: "onCampusRecruitingIncluded",
                choice: "On-campus recruiting §",
                choiceLabelHidden: true,
                reviewHidden: true,
              },
              {
                widget: "label",
                label: "On-campus recruiting §",
              },
              {
                widget: "date",
                machine_name: "onCampusRecruitingFrom",
                label: "4.a",
                code: "H.d.4a",
                disabled: true,
                // hideIcons: true,
                noFixedWidth: true,
                tooltip:
                  "Enter the start date for the on-campus recruiting in MM/DD/YYYY format.",
                maxDate: "onCampusRecruitingTo",
                disableWhenField: {
                  when: "onCampusRecruitingIncluded",
                  is: 0,
                },
                cellWarning: {
                  text: "The recruitment steps must be conducted at least 30 days, but no more than 180 days, before filing the application.",
                  isVisible: {
                    when: (formApi) => {
                      const value =
                        formApi.getState().values.onCampusRecruitingFrom;
                      const errors =
                        formApi.getState().errors.onCampusRecruitingFrom;
                      const included =
                        formApi.getState().values.onCampusRecruitingIncluded;
                      if (!!included && !!value && !errors) {
                        const today = moment();
                        const dateToCheck = moment(value);
                        const diff = Math.round(
                          today.diff(dateToCheck, "days", true)
                        );
                        return diff > 180 || diff < 30;
                      }
                      return false;
                    },
                    is: "onCampusRecruitingFromCheck",
                    operator: "customValidation",
                  },
                },
                validate: [
                  {
                    isRequired: "onCampusRecruitingIncluded",
                    message: "This field is required",
                    needsFieldValues: true,
                    extraData: {
                      valueOf: 1,
                    },
                  },
                  {
                    dateStartEnd: "onCampusRecruitingTo",
                    message: "From Date must occur before To Date.",
                    needsFieldValues: true,
                    extraData: {
                      type: "start",
                      validateWhen: {
                        field: "onCampusRecruitingIncluded",
                        is: 1,
                      },
                    },
                  },
                ],
              },
              {
                widget: "date",
                machine_name: "onCampusRecruitingTo",
                label: "4.b",
                code: "H.d.4b",
                disabled: true,
                // hideIcons: true,
                noFixedWidth: true,
                tooltip:
                  "Enter the end date for the on-campus recruiting in MM/DD/YYYY format.",
                minDate: "onCampusRecruitingFrom",
                disableWhenField: {
                  when: "onCampusRecruitingIncluded",
                  is: 0,
                },
                cellWarning: {
                  text: "The recruitment steps must be conducted at least 30 days, but no more than 180 days, before filing the application.",
                  isVisible: {
                    when: (formApi) => {
                      const value =
                        formApi.getState().values.onCampusRecruitingTo;
                      const errors =
                        formApi.getState().errors.onCampusRecruitingTo;
                      const included =
                        formApi.getState().values.onCampusRecruitingIncluded;
                      if (!!included && !!value && !errors) {
                        const today = moment();
                        const dateToCheck = moment(value);
                        const diff = Math.round(
                          today.diff(dateToCheck, "days", true)
                        );
                        return diff > 180 || diff < 30;
                      }
                      return false;
                    },
                    is: "onCampusRecruitingToCheck",
                    operator: "customValidation",
                  },
                },
                validate: [
                  {
                    isRequired: "onCampusRecruitingIncluded",
                    message: "This field is required",
                    needsFieldValues: true,
                    extraData: {
                      valueOf: 1,
                    },
                  },
                  {
                    dateStartEnd: "onCampusRecruitingFrom",
                    message: "End Date must occur after Begin Date.",
                    needsFieldValues: true,
                    extraData: {
                      type: "end",
                      validateWhen: {
                        field: "onCampusRecruitingIncluded",
                        is: 1,
                      },
                    },
                  },
                ],
              },
            ],
            [
              {
                widget: "checkbox",
                machine_name: "tradeProfessionalIncluded",
                choice: "Trade or professional organization §",
                choiceLabelHidden: true,
                reviewHidden: true,
              },
              {
                widget: "label",
                label: "Trade or professional organization §",
              },
              {
                widget: "date",
                machine_name: "tradeProfessionalFrom",
                label: "5.a",
                code: "H.d.5a",
                disabled: true,
                // hideIcons: true,
                noFixedWidth: true,
                tooltip:
                  "Enter the start date for the trade or professional organization recruitment in MM/DD/YYYY format.",
                maxDate: "tradeProfessionalTo",
                disableWhenField: {
                  when: "tradeProfessionalIncluded",
                  is: 0,
                },
                cellWarning: {
                  text: "The recruitment steps must be conducted at least 30 days, but no more than 180 days, before filing the application.",
                  isVisible: {
                    when: (formApi) => {
                      const value =
                        formApi.getState().values.tradeProfessionalFrom;
                      const errors =
                        formApi.getState().errors.tradeProfessionalFrom;
                      const included =
                        formApi.getState().values.tradeProfessionalIncluded;
                      if (!!included && !!value && !errors) {
                        const today = moment();
                        const dateToCheck = moment(value);
                        const diff = Math.round(
                          today.diff(dateToCheck, "days", true)
                        );
                        return diff > 180 || diff < 30;
                      }
                      return false;
                    },
                    is: "tradeProfessionalFromCheck",
                    operator: "customValidation",
                  },
                },
                validate: [
                  {
                    isRequired: "tradeProfessionalIncluded",
                    message: "This field is required",
                    needsFieldValues: true,
                    extraData: {
                      valueOf: 1,
                    },
                  },
                  {
                    dateStartEnd: "tradeProfessionalTo",
                    message: "From Date must occur before To Date.",
                    needsFieldValues: true,
                    extraData: {
                      type: "start",
                      validateWhen: {
                        field: "tradeProfessionalIncluded",
                        is: 1,
                      },
                    },
                  },
                ],
              },
              {
                widget: "date",
                machine_name: "tradeProfessionalTo",
                label: "5.b",
                code: "H.d.5b",
                disabled: true,
                // hideIcons: true,
                noFixedWidth: true,
                tooltip:
                  "Enter the end date for the trade or professional organization recruitment in MM/DD/YYYY format.",
                minDate: "tradeProfessionalFrom",
                disableWhenField: {
                  when: "tradeProfessionalIncluded",
                  is: 0,
                },
                cellWarning: {
                  text: "The recruitment steps must be conducted at least 30 days, but no more than 180 days, before filing the application.",
                  isVisible: {
                    when: (formApi) => {
                      const value =
                        formApi.getState().values.tradeProfessionalTo;
                      const errors =
                        formApi.getState().errors.tradeProfessionalTo;
                      const included =
                        formApi.getState().values.tradeProfessionalIncluded;
                      if (!!included && !!value && !errors) {
                        const today = moment();
                        const dateToCheck = moment(value);
                        const diff = Math.round(
                          today.diff(dateToCheck, "days", true)
                        );
                        return diff > 180 || diff < 30;
                      }
                      return false;
                    },
                    is: "tradeProfessionalToCheck",
                    operator: "customValidation",
                  },
                },
                validate: [
                  {
                    isRequired: "tradeProfessionalIncluded",
                    message: "This field is required",
                    needsFieldValues: true,
                    extraData: {
                      valueOf: 1,
                    },
                  },
                  {
                    dateStartEnd: "tradeProfessionalFrom",
                    message: "End Date must occur after Begin Date.",
                    needsFieldValues: true,
                    extraData: {
                      type: "end",
                      validateWhen: {
                        field: "tradeProfessionalIncluded",
                        is: 1,
                      },
                    },
                  },
                ],
              },
            ],
            [
              {
                widget: "checkbox",
                machine_name: "privateEmploymentIncluded",
                choice: "Private employment firm §",
                choiceLabelHidden: true,
                reviewHidden: true,
              },
              {
                widget: "label",
                label: "Private employment firm §",
              },
              {
                widget: "date",
                machine_name: "privateEmploymentFrom",
                label: "6.a",
                code: "H.d.6a",
                disabled: true,
                // hideIcons: true,
                noFixedWidth: true,
                tooltip:
                  "Enter the start date for the private employment firm recruitment in MM/DD/YYYY format.",
                maxDate: "privateEmploymentTo",
                disableWhenField: {
                  when: "privateEmploymentIncluded",
                  is: 0,
                },
                cellWarning: {
                  text: "The recruitment steps must be conducted at least 30 days, but no more than 180 days, before filing the application.",
                  isVisible: {
                    when: (formApi) => {
                      const value =
                        formApi.getState().values.privateEmploymentFrom;
                      const errors =
                        formApi.getState().errors.privateEmploymentFrom;
                      const included =
                        formApi.getState().values.privateEmploymentIncluded;
                      if (!!included && !!value && !errors) {
                        const today = moment();
                        const dateToCheck = moment(value);
                        const diff = Math.round(
                          today.diff(dateToCheck, "days", true)
                        );
                        return diff > 180 || diff < 30;
                      }
                      return false;
                    },
                    is: "privateEmploymentFromCheck",
                    operator: "customValidation",
                  },
                },
                validate: [
                  {
                    isRequired: "privateEmploymentIncluded",
                    message: "This field is required",
                    needsFieldValues: true,
                    extraData: {
                      valueOf: 1,
                    },
                  },
                  {
                    dateStartEnd: "privateEmploymentTo",
                    message: "From Date must occur before To Date.",
                    needsFieldValues: true,
                    extraData: {
                      type: "start",
                      validateWhen: {
                        field: "privateEmploymentIncluded",
                        is: 1,
                      },
                    },
                  },
                ],
              },
              {
                widget: "date",
                machine_name: "privateEmploymentTo",
                label: "6.b",
                code: "H.d.6b",
                disabled: true,
                // hideIcons: true,
                noFixedWidth: true,
                tooltip:
                  "Enter the end date for the private employment firm recruitment in MM/DD/YYYY format.",
                minDate: "privateEmploymentFrom",
                disableWhenField: {
                  when: "privateEmploymentIncluded",
                  is: 0,
                },
                cellWarning: {
                  text: "The recruitment steps must be conducted at least 30 days, but no more than 180 days, before filing the application.",
                  isVisible: {
                    when: (formApi) => {
                      const value =
                        formApi.getState().values.privateEmploymentTo;
                      const errors =
                        formApi.getState().errors.privateEmploymentTo;
                      const included =
                        formApi.getState().values.privateEmploymentIncluded;
                      if (!!included && !!value && !errors) {
                        const today = moment();
                        const dateToCheck = moment(value);
                        const diff = Math.round(
                          today.diff(dateToCheck, "days", true)
                        );
                        return diff > 180 || diff < 30;
                      }
                      return false;
                    },
                    is: "privateEmploymentToCheck",
                    operator: "customValidation",
                  },
                },
                validate: [
                  {
                    isRequired: "privateEmploymentIncluded",
                    message: "This field is required",
                    needsFieldValues: true,
                    extraData: {
                      valueOf: 1,
                    },
                  },
                  {
                    dateStartEnd: "privateEmploymentFrom",
                    message: "End Date must occur after Begin Date.",
                    needsFieldValues: true,
                    extraData: {
                      type: "end",
                      validateWhen: {
                        field: "privateEmploymentIncluded",
                        is: 1,
                      },
                    },
                  },
                ],
              },
            ],
            [
              {
                widget: "checkbox",
                machine_name: "employeeReferralIncluded",
                choice: "Employee referral program §",
                choiceLabelHidden: true,
                reviewHidden: true,
              },
              {
                widget: "label",
                label: "Employee referral program §",
              },
              {
                widget: "date",
                machine_name: "employeeReferralFrom",
                label: "7.a",
                code: "H.d.7a",
                disabled: true,
                // hideIcons: true,
                noFixedWidth: true,
                tooltip:
                  "Enter the start date for the employee referral program in MM/DD/YYYY format.",
                maxDate: "employeeReferralTo",
                disableWhenField: {
                  when: "employeeReferralIncluded",
                  is: 0,
                },
                cellWarning: {
                  text: "The recruitment steps must be conducted at least 30 days, but no more than 180 days, before filing the application.",
                  isVisible: {
                    when: (formApi) => {
                      const value =
                        formApi.getState().values.employeeReferralFrom;
                      const errors =
                        formApi.getState().errors.employeeReferralFrom;
                      const included =
                        formApi.getState().values.employeeReferralIncluded;
                      if (!!included && !!value && !errors) {
                        const today = moment();
                        const dateToCheck = moment(value);
                        const diff = Math.round(
                          today.diff(dateToCheck, "days", true)
                        );
                        return diff > 180 || diff < 30;
                      }
                      return false;
                    },
                    is: "employeeReferralFromCheck",
                    operator: "customValidation",
                  },
                },
                validate: [
                  {
                    isRequired: "employeeReferralIncluded",
                    message: "This field is required",
                    needsFieldValues: true,
                    extraData: {
                      valueOf: 1,
                    },
                  },
                  {
                    dateStartEnd: "employeeReferralTo",
                    message: "From Date must occur before To Date.",
                    needsFieldValues: true,
                    extraData: {
                      type: "start",
                      validateWhen: {
                        field: "employeeReferralIncluded",
                        is: 1,
                      },
                    },
                  },
                ],
              },
              {
                widget: "date",
                machine_name: "employeeReferralTo",
                label: "7.b",
                code: "H.d.7b",
                disabled: true,
                // hideIcons: true,
                noFixedWidth: true,
                tooltip:
                  "Enter the end date for the employee referral program in MM/DD/YYYY format.",
                minDate: "employeeReferralFrom",
                disableWhenField: {
                  when: "employeeReferralIncluded",
                  is: 0,
                },
                cellWarning: {
                  text: "The recruitment steps must be conducted at least 30 days, but no more than 180 days, before filing the application.",
                  isVisible: {
                    when: (formApi) => {
                      const value =
                        formApi.getState().values.employeeReferralTo;
                      const errors =
                        formApi.getState().errors.employeeReferralTo;
                      const included =
                        formApi.getState().values.employeeReferralIncluded;
                      if (!!included && !!value && !errors) {
                        const today = moment();
                        const dateToCheck = moment(value);
                        const diff = Math.round(
                          today.diff(dateToCheck, "days", true)
                        );
                        return diff > 180 || diff < 30;
                      }
                      return false;
                    },
                    is: "employeeReferralToCheck",
                    operator: "customValidation",
                  },
                },
                validate: [
                  {
                    isRequired: "employeeReferralIncluded",
                    message: "This field is required",
                    needsFieldValues: true,
                    extraData: {
                      valueOf: 1,
                    },
                  },
                  {
                    dateStartEnd: "employeeReferralFrom",
                    message: "End Date must occur after Begin Date.",
                    needsFieldValues: true,
                    extraData: {
                      type: "end",
                      validateWhen: {
                        field: "employeeReferralIncluded",
                        is: 1,
                      },
                    },
                  },
                ],
              },
            ],
            [
              {
                widget: "checkbox",
                machine_name: "campusPlacementIncluded",
                choice: "Campus placement office §",
                choiceLabelHidden: true,
                reviewHidden: true,
              },
              {
                widget: "label",
                label: "Campus placement office §",
              },
              {
                widget: "date",
                machine_name: "campusPlacementFrom",
                label: "8.a",
                code: "H.d.8a",
                disabled: true,
                // hideIcons: true,
                noFixedWidth: true,
                tooltip:
                  "Enter the start date for the campus placement office recruitment in MM/DD/YYYY format.",
                maxDate: "campusPlacementTo",
                disableWhenField: {
                  when: "campusPlacementIncluded",
                  is: 0,
                },
                cellWarning: {
                  text: "The recruitment steps must be conducted at least 30 days, but no more than 180 days, before filing the application.",
                  isVisible: {
                    when: (formApi) => {
                      const value =
                        formApi.getState().values.campusPlacementFrom;
                      const errors =
                        formApi.getState().errors.campusPlacementFrom;
                      const included =
                        formApi.getState().values.campusPlacementIncluded;
                      if (!!included && !!value && !errors) {
                        const today = moment();
                        const dateToCheck = moment(value);
                        const diff = Math.round(
                          today.diff(dateToCheck, "days", true)
                        );
                        return diff > 180 || diff < 30;
                      }
                      return false;
                    },
                    is: "campusPlacementFromCheck",
                    operator: "customValidation",
                  },
                },
                validate: [
                  {
                    isRequired: "campusPlacementIncluded",
                    message: "This field is required",
                    needsFieldValues: true,
                    extraData: {
                      valueOf: 1,
                    },
                  },
                  {
                    dateStartEnd: "campusPlacementTo",
                    message: "From Date must occur before To Date.",
                    needsFieldValues: true,
                    extraData: {
                      type: "start",
                      validateWhen: {
                        field: "campusPlacementIncluded",
                        is: 1,
                      },
                    },
                  },
                ],
              },
              {
                widget: "date",
                machine_name: "campusPlacementTo",
                label: "8.b",
                code: "H.d.8b",
                disabled: true,
                // hideIcons: true,
                noFixedWidth: true,
                tooltip:
                  "Enter the end date for the campus placement office recruitment in MM/DD/YYYY format.",
                minDate: "campusPlacementFrom",
                disableWhenField: {
                  when: "campusPlacementIncluded",
                  is: 0,
                },
                cellWarning: {
                  text: "The recruitment steps must be conducted at least 30 days, but no more than 180 days, before filing the application.",
                  isVisible: {
                    when: (formApi) => {
                      const value = formApi.getState().values.campusPlacementTo;
                      const errors =
                        formApi.getState().errors.campusPlacementTo;
                      const included =
                        formApi.getState().values.campusPlacementIncluded;
                      if (!!included && !!value && !errors) {
                        const today = moment();
                        const dateToCheck = moment(value);
                        const diff = Math.round(
                          today.diff(dateToCheck, "days", true)
                        );
                        return diff > 180 || diff < 30;
                      }
                      return false;
                    },
                    is: "campusPlacementToCheck",
                    operator: "customValidation",
                  },
                },
                validate: [
                  {
                    isRequired: "campusPlacementIncluded",
                    message: "This field is required",
                    needsFieldValues: true,
                    extraData: {
                      valueOf: 1,
                    },
                  },
                  {
                    dateStartEnd: "campusPlacementFrom",
                    message: "End Date must occur after Begin Date.",
                    needsFieldValues: true,
                    extraData: {
                      type: "end",
                      validateWhen: {
                        field: "campusPlacementIncluded",
                        is: 1,
                      },
                    },
                  },
                ],
              },
            ],
            [
              {
                widget: "checkbox",
                machine_name: "localEthnicNewspaperIncluded",
                choice: "Local or ethnic newspaper §",
                choiceLabelHidden: true,
                reviewHidden: true,
              },
              {
                widget: "label",
                label: "Local or ethnic newspaper §",
              },
              {
                widget: "date",
                machine_name: "localEthnicNewspaperFrom",
                label: "9.a",
                code: "H.d.9a",
                disabled: true,
                // hideIcons: true,
                noFixedWidth: true,
                tooltip:
                  "Enter the start date for the local or ethnic newspaper recruitment in MM/DD/YYYY format.",
                maxDate: "localEthnicNewspaperTo",
                disableWhenField: {
                  when: "localEthnicNewspaperIncluded",
                  is: 0,
                },
                cellWarning: {
                  text: "The recruitment steps must be conducted at least 30 days, but no more than 180 days, before filing the application.",
                  isVisible: {
                    when: (formApi) => {
                      const value =
                        formApi.getState().values.localEthnicNewspaperFrom;
                      const errors =
                        formApi.getState().errors.localEthnicNewspaperFrom;
                      const included =
                        formApi.getState().values.localEthnicNewspaperIncluded;
                      if (!!included && !!value && !errors) {
                        const today = moment();
                        const dateToCheck = moment(value);
                        const diff = Math.round(
                          today.diff(dateToCheck, "days", true)
                        );
                        return diff > 180 || diff < 30;
                      }
                      return false;
                    },
                    is: "localEthnicNewspaperFromCheck",
                    operator: "customValidation",
                  },
                },
                validate: [
                  {
                    isRequired: "localEthnicNewspaperIncluded",
                    message: "This field is required",
                    needsFieldValues: true,
                    extraData: {
                      valueOf: 1,
                    },
                  },
                  {
                    dateStartEnd: "localEthnicNewspaperTo",
                    message: "From Date must occur before To Date.",
                    needsFieldValues: true,
                    extraData: {
                      type: "start",
                      validateWhen: {
                        field: "localEthnicNewspaperIncluded",
                        is: 1,
                      },
                    },
                  },
                ],
              },
              {
                widget: "date",
                machine_name: "localEthnicNewspaperTo",
                label: "9.b",
                code: "H.d.9b",
                disabled: true,
                // hideIcons: true,
                noFixedWidth: true,
                tooltip:
                  "Enter the end date for the local or ethnic newspaper recruitment in MM/DD/YYYY format.",
                minDate: "localEthnicNewspaperFrom",
                disableWhenField: {
                  when: "localEthnicNewspaperIncluded",
                  is: 0,
                },
                cellWarning: {
                  text: "The recruitment steps must be conducted at least 30 days, but no more than 180 days, before filing the application.",
                  isVisible: {
                    when: (formApi) => {
                      const value =
                        formApi.getState().values.localEthnicNewspaperTo;
                      const errors =
                        formApi.getState().errors.localEthnicNewspaperTo;
                      const included =
                        formApi.getState().values.localEthnicNewspaperIncluded;
                      if (!!included && !!value && !errors) {
                        const today = moment();
                        const dateToCheck = moment(value);
                        const diff = Math.round(
                          today.diff(dateToCheck, "days", true)
                        );
                        return diff > 180 || diff < 30;
                      }
                      return false;
                    },
                    is: "localEthnicNewspaperToCheck",
                    operator: "customValidation",
                  },
                },
                validate: [
                  {
                    isRequired: "localEthnicNewspaperIncluded",
                    message: "This field is required",
                    needsFieldValues: true,
                    extraData: {
                      valueOf: 1,
                    },
                  },
                  {
                    dateStartEnd: "localEthnicNewspaperFrom",
                    message: "End Date must occur after Begin Date.",
                    needsFieldValues: true,
                    extraData: {
                      type: "end",
                      validateWhen: {
                        field: "localEthnicNewspaperIncluded",
                        is: 1,
                      },
                    },
                  },
                ],
              },
            ],
            [
              {
                widget: "checkbox",
                machine_name: "radioTvAdIncluded",
                choice: "Radio and/or TV advertisement §",
                choiceLabelHidden: true,
                reviewHidden: true,
              },
              {
                widget: "label",
                label: "Radio and/or TV advertisement §",
              },
              {
                widget: "date",
                machine_name: "radioTvAdFrom",
                label: "10.a",
                code: "H.d.10a",
                disabled: true,
                // hideIcons: true,
                noFixedWidth: true,
                tooltip:
                  "Enter the start date for the radio and/or TV advertisement in MM/DD/YYYY format.",
                maxDate: "radioTvAdTo",
                disableWhenField: {
                  when: "radioTvAdIncluded",
                  is: 0,
                },
                cellWarning: {
                  text: "The recruitment steps must be conducted at least 30 days, but no more than 180 days, before filing the application.",
                  isVisible: {
                    when: (formApi) => {
                      const value = formApi.getState().values.radioTvAdFrom;
                      const errors = formApi.getState().errors.radioTvAdFrom;
                      const included =
                        formApi.getState().values.radioTvAdIncluded;
                      if (!!included && !!value && !errors) {
                        const today = moment();
                        const dateToCheck = moment(value);
                        const diff = Math.round(
                          today.diff(dateToCheck, "days", true)
                        );
                        return diff > 180 || diff < 30;
                      }
                      return false;
                    },
                    is: "radioTvAdFromCheck",
                    operator: "customValidation",
                  },
                },
                validate: [
                  {
                    isRequired: "radioTvAdIncluded",
                    message: "This field is required",
                    needsFieldValues: true,
                    extraData: {
                      valueOf: 1,
                    },
                  },
                  {
                    dateStartEnd: "radioTvAdTo",
                    message: "From Date must occur before To Date.",
                    needsFieldValues: true,
                    extraData: {
                      type: "start",
                      validateWhen: {
                        field: "radioTvAdIncluded",
                        is: 1,
                      },
                    },
                  },
                ],
              },
              {
                widget: "date",
                machine_name: "radioTvAdTo",
                label: "10.b",
                code: "H.d.10b",
                disabled: true,
                // hideIcons: true,
                noFixedWidth: true,
                tooltip:
                  "Enter the end date for the radio and/or TV advertisement in MM/DD/YYYY format.",
                minDate: "radioTvAdFrom",
                disableWhenField: {
                  when: "radioTvAdIncluded",
                  is: 0,
                },
                cellWarning: {
                  text: "The recruitment steps must be conducted at least 30 days, but no more than 180 days, before filing the application.",
                  isVisible: {
                    when: (formApi) => {
                      const value = formApi.getState().values.radioTvAdTo;
                      const errors = formApi.getState().errors.radioTvAdTo;
                      const included =
                        formApi.getState().values.radioTvAdIncluded;
                      if (!!included && !!value && !errors) {
                        const today = moment();
                        const dateToCheck = moment(value);
                        const diff = Math.round(
                          today.diff(dateToCheck, "days", true)
                        );
                        return diff > 180 || diff < 30;
                      }
                      return false;
                    },
                    is: "radioTvAdToCheck",
                    operator: "customValidation",
                  },
                },
                validate: [
                  {
                    isRequired: "radioTvAdIncluded",
                    message: "This field is required",
                    needsFieldValues: true,
                    extraData: {
                      valueOf: 1,
                    },
                  },
                  {
                    dateStartEnd: "radioTvAdFrom",
                    message: "End Date must occur after Begin Date.",
                    needsFieldValues: true,
                    extraData: {
                      type: "end",
                      validateWhen: {
                        field: "radioTvAdIncluded",
                        is: 1,
                      },
                    },
                  },
                ],
              },
            ],
          ],
        },
      ],
    },
  ],
};
